// extracted by mini-css-extract-plugin
module.exports = {"commonContainer":"not-found_commonContainer__33tBC","formContainer":"not-found_formContainer__2Nx9W","headerContainer":"not-found_headerContainer__3rTe-"};